// const default_colors = {};
function onLoadLayout() {
  // 初期値を確認
  switchPageColor();

  // 共通パーツ
  menu();
  setHeaderOffset();
  setHeaderListPadding();
  scrollClass();
  newsPostTicker();

  initMouseFollower();

  initLoadingScreen();
}

function onLoadPage() {
  // 各ページ
  filter();
  freeScrollContainer();
  cmnSwiper();
  topPage();
  productPage();
  storyPage();
  storySingle();
  accordion();
  newsLetterPage();
  gallery();
  itemsCatArchive();
  alignItemsHeight();
  initMapSvg();
  aboutPage();
  voidPage();
}
document.addEventListener('DOMContentLoaded', () => {
  onLoadLayout();
  onLoadPage();
});

try {
  FONTPLUS.attachCompleteEvent((e) => {
    // console.log(e);
    const evt = new Event('fontsload');
    window.dispatchEvent(evt);
  });
} catch (err) {
  // console.log(err);
  const evt = new Event('fontsload');
  window.dispatchEvent(evt);
}

try {
  swup.hooks.on('page:view', (visit) => {
    reloadFonts();
    onLoadPage();

    // console.log(visit.to);
    // if (/\/void/.test(visit.to.url)) {
    //   bodyColorVoid(true);
    // } else if (/\/void/.test(visit.from.url)) {
    //   bodyColorVoid(false);
    // }
    switchPageColor(visit.to.url);

    // スクロール固定がかかっている場合は解除
    bodyScrollToggle(false);

    // pageViewを送信する
    gaPageView(visit);
  });
} catch (err) {}

try {
  swup.hooks.on('link:anchor', (visit) => {
    // document.querySelector(visit.to.hash).focus();
    // console.log(visit.to);
    location.href = visit.to.url + visit.to.hash;
  });
} catch (err) {}

function gaPageView(visit) {
  try {
    gtag('event', 'page_view', {
      page_title: document.title,
      page_path: visit.to.url,
    });
  } catch (err) {
    console.log(err);
  }
}

function initLoadingScreen() {
  const loading_screen = document.querySelector('#loadingScreen');
  const loading_logo = document.querySelector('#logoLoading');
  if (!loading_screen || !loading_logo) {
    return false;
  }
  function showLoading() {
    loading_logo.classList.remove('is-active');
    loading_screen.classList.add('is-active');
  }

  function startLoading() {
    const image_loading = imagesLoaded('#MainContent');
    const to_load_elems = image_loading.images.length + 1; // フォントの分をプラス
    const timeout = 3000;
    let loaded_elems = 0;
    let timer;

    // SVGのの準備
    const path_a = loading_logo.querySelector('#loadingLogoPathA');
    const path_b = loading_logo.querySelector('#loadingLogoPathB');
    const path_a_length = path_a.getTotalLength();
    const path_b_length = path_b.getTotalLength();
    let current_progress = 0;

    gsap.set(path_a, {
      strokeDashoffset: path_a_length * -1,
      strokeDasharray: `${path_a_length} ${path_a_length}`,
    });
    gsap.set(path_b, {
      strokeDashoffset: path_b_length * -1,
      strokeDasharray: `${path_b_length} ${path_b_length}`,
    });
    let path_tl_a = gsap.quickTo(path_a, 'strokeDashoffset', { duration: 0.2, ease: 'sine.out' });
    let path_tl_b = gsap.quickTo(path_b, 'strokeDashoffset', { duration: 0.2, ease: 'sine.out' });

    function moveStroke() {
      path_tl_a(-1 * (1 - current_progress) * path_a_length);
      path_tl_b(-1 * (1 - current_progress) * path_b_length);
    }

    function progress() {
      current_progress = Math.max(
        current_progress + (loaded_elems / to_load_elems - current_progress) * 0.085,
        current_progress
      );
      current_progress = 0.001 * Math.ceil(current_progress * 1000);
      moveStroke();
      if (current_progress == 1) {
        gsap.ticker.remove(progress);
        setTimeout(finish, 300);
      }
    }
    gsap.ticker.remove(progress);
    gsap.ticker.add(progress);

    function finish() {
      clearTimeout(timer);
      hideLoading();
    }
    function detectFontLoad() {
      loaded_elems++;
    }
    function detectImageLoad() {
      loaded_elems++;
    }
    image_loading.on('progress', detectImageLoad);
    window.addEventListener('fontsload', detectFontLoad, { once: true });
    timer = setTimeout(() => {
      current_progress = 1;
    }, timeout);

    loading_screen.classList.add('is-loading');
    loading_logo.classList.add('is-active');
  }

  function hideLoading() {
    loading_screen.classList.remove('is-active');
    loading_screen.classList.remove('is-loading');
    loading_logo.classList.remove('is-active');
  }

  try {
    swup.hooks.on('animation:out:start', () => {
      showLoading();
    });
    swup.hooks.on('content:replace', () => {
      startLoading();
    });
  } catch (err) {}
  if (!document.querySelector('#introWrap')) {
    startLoading();
  } else {
    hideLoading();
  }
}

function reloadFonts() {
  try {
    if (!document.querySelector('pickup-availability')) {
      requestAnimationFrame(() => {
        FONTPLUS.reload();
      });
    }
  } catch (err) {
    // console.log(err);
  }
}

function aboutPage() {
  const about_page = document.querySelector('#about');
  if (about_page) {
    let mql = window.matchMedia('(max-width:800px)');
    const slider = document.querySelector('.aboutC__fig');
    let swiper;
    function toggleSlider() {
      if (mql.matches) {
        if (slider && slider.swiper == null) {
          const swpr = new Swiper(slider, {
            direction: 'horizontal',
            slidesPerView: 'auto',
            freeMode: true,
            on: {
              init: (e) => {
                // console.log(e);
                setTimeout(() => {
                  requestAnimationFrame(() => {
                    const pos = slider.swiper.maxTranslate();
                    slider.swiper.translateTo(pos, 400, true, false);
                  });
                });
              },
            },
            onAny(eventName, ...args) {
              if (eventName == 'touchMove') {
                const event = new Event('swiperdragging');
                event.clientX = args[1].clientX;
                event.clientY = args[1].clientY;
                window.dispatchEvent(event);
              } else if (eventName == 'touchStart') {
                const event = new Event('swiperdragstart');
                window.dispatchEvent(event);
              } else if (eventName == 'touchEnd') {
                const event = new Event('swiperdragend');
                window.dispatchEvent(event);
              }
            },
          });

          function slideBack() {
            const rect = slider.getBoundingClientRect();
            const offset = 0.1;
            if (rect.top - rect.height * offset >= 0 && rect.top <= window.innerHeight - rect.height * offset) {
              window.removeEventListener('scroll', slideBack);
              const pos = slider.swiper.minTranslate();
              slider.swiper.translateTo(pos, 1400, true, false);
            }
          }
          window.addEventListener('scroll', slideBack);
        } else if (slider && slider.swiper != null) {
          slider.swiper.enable();
        }
      } else if (slider && slider.swiper != null) {
        slider.swiper.disable();
      }
    }
    mql.addEventListener('change', toggleSlider);
    toggleSlider();
  }
}

function voidPage() {
  const slider = document.querySelector('.voidReserve__main .fig');
  if (slider) {
    console.log(slider);

    let mql = window.matchMedia('(max-width:800px)');
    let swiper;
    function toggleSlider() {
      if (mql.matches) {
        if (slider && slider.swiper == null) {
          const swpr = new Swiper(slider, {
            direction: 'horizontal',
            slidesPerView: 'auto',
            freeMode: true,
            on: {
              init: (e) => {
                // console.log(e);
                setTimeout(() => {
                  requestAnimationFrame(() => {
                    const pos = slider.swiper.maxTranslate();
                    slider.swiper.translateTo(pos, 400, true, false);
                  });
                });
              },
            },
            onAny(eventName, ...args) {
              if (eventName == 'touchMove') {
                const event = new Event('swiperdragging');
                event.clientX = args[1].clientX;
                event.clientY = args[1].clientY;
                window.dispatchEvent(event);
              } else if (eventName == 'touchStart') {
                const event = new Event('swiperdragstart');
                window.dispatchEvent(event);
              } else if (eventName == 'touchEnd') {
                const event = new Event('swiperdragend');
                window.dispatchEvent(event);
              }
            },
          });

          function slideBack() {
            const rect = slider.getBoundingClientRect();
            const offset = 0.1;
            if (rect.top - rect.height * offset >= 0 && rect.top <= window.innerHeight - rect.height * offset) {
              window.removeEventListener('scroll', slideBack);
              const pos = slider.swiper.minTranslate();
              slider.swiper.translateTo(pos, 1400, true, false);
            }
          }
          window.addEventListener('scroll', slideBack);
        } else if (slider && slider.swiper != null) {
          slider.swiper.enable();
        }
      } else if (slider && slider.swiper != null) {
        slider.swiper.disable();
      }
    }
    mql.addEventListener('change', toggleSlider);
    toggleSlider();
  }
}

function initMapSvg() {
  const map = document.querySelector('.accessMapSvg');
  if (map) {
    const marker = map.querySelector('#WonderingIsHere');
    const tl = gsap.timeline({
      repeat: -1,
      yoyo: true,
    });
    tl.fromTo(
      marker,
      {
        r: 5,
        fill: '#FFFF00FF',
        strokeWidth: 1.95,
      },
      {
        r: 18,
        fill: '#FFFF0000',
        strokeWidth: 3,
        duration: 1,
        ease: 'power1.inOut',
      }
    );
  }
}

function switchPageColor(url) {
  // console.log(url);

  const test_url = url != null ? url : location.href;
  if (/\/stories/.test(test_url)) {
    pageColorTo('stories');
  } else if (/\/about/.test(test_url) || /\/selector/.test(test_url)) {
    pageColorTo('about');
  } else if (/\/void/.test(test_url)) {
    pageColorTo('void');
  } else {
    pageColorTo('default');
  }
}

let current_color_scheme = 'default';
function pageColorTo(name = 'default') {
  // console.log(color_schemes);
  const switch_duration = 0.8;
  if (color_schemes == null) {
    return false;
  }
  if (color_schemes[name] != null && name != current_color_scheme) {
    console.log('change color to:', name);

    gsap.fromTo(
      document.body,
      {
        '--main-bg-color': color_schemes[current_color_scheme].background,
        '--main-bg-rgb': gsap.utils.splitColor(color_schemes[current_color_scheme].background),
        '--main-txt-color': color_schemes[current_color_scheme].color,
        '--main-txt-rgb': gsap.utils.splitColor(color_schemes[current_color_scheme].color),
      },
      {
        '--main-bg-color': color_schemes[name].background,
        '--main-bg-rgb': gsap.utils.splitColor(color_schemes[name].background),
        '--main-txt-color': color_schemes[name].color,
        '--main-txt-rgb': gsap.utils.splitColor(color_schemes[name].color),
        duration: switch_duration,
      }
    );
    current_color_scheme = name;
  }
}

function setHeaderOffset() {
  function reset() {
    const lists = document.querySelectorAll('.menuPageList,.menuLinkList');
    Array.from(lists).forEach((list) => {
      list.style.setProperty('--pad', `0px`);
      requestAnimationFrame(() => {
        const list_items = list.querySelectorAll('li:not(.tbmin)');
        const txts = list.querySelectorAll('.txt .en');
        const txt_width_all = Array.from(txts).reduce((accumulator, elem) => {
          return accumulator + elem.offsetWidth;
        }, 0);
        const list_width = list.offsetWidth;
        list.style.setProperty('--pad', `${(list_width - txt_width_all) / (list_items.length * 2)}px`);
        Array.from(list_items).forEach((item) => {
          if (!item.classList.contains('is-active')) {
            item.classList.add('is-active');
          }
        });
      });
    });
  }
  window.addEventListener('fontsload', reset);
  window.addEventListener('resize', reset);
  reset();
}

function setHeaderListPadding() {
  function reset() {
    const header = document.querySelector('header.head');
    if (!header) {
      return;
    }
    document.documentElement.style.setProperty('--header-offset', `${header.offsetHeight}px`);
  }
  window.addEventListener('fontsload', reset);
  window.addEventListener('resize', reset);
  reset();
}

window.clickFav = function () {
  const tgt = document.querySelector('loo-lists-bar a.loo-db');
  if (tgt) {
    tgt.click();
    setTimeout(() => {
      const wishlist_wraper = document.querySelector('.loo-wishlist-wraper');
      if (wishlist_wraper) {
        wishlist_wraper.matchHeight({
          elements: '._brand',
        });
      }
      requestAnimationFrame(getItemVendors);
    }, 100);
  }
};

// お気に入りボタン
function getItemVendors() {
  const list = JSON.parse(localStorage.getItem('loo-wishlist'));
  const url = new URL(location.href);
  if (list != null) {
    const keys = Object.keys(list);
    const handles = [];
    keys.forEach((key) => {
      const item = list[key];
      const elem = document.querySelector(`.loo-db[href="/products/${item.handle}"]`);
      if (elem) {
        if (!elem.querySelector('.loo-wishlist-item-title ._brand')) {
          const brand = document.createElement('SPAN');
          brand.classList.add('_brand');
          elem.querySelector('.loo-wishlist-item-title').prepend(brand);
          fetch('https://' + url.host + '/products/' + item.handle + '.js', {
            method: 'GET',
            headers: { 'Content-type': 'application/json; charset=UTF-8' },
          })
            .then((response) => response.json())
            .then((product) => {
              // console.log(product);
              brand.textContent = product.vendor;
              window.dispatchEvent(new Event('resize'));
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    });
  }
}

function initMouseFollower() {
  const follower = document.querySelector('#mouseFollower');
  if (follower) {
    let mm = gsap.matchMedia();
    let page_moving = false;
    let position_cache = {};
    mm.add('(any-pointer: fine)', () => {
      let xTo = gsap.quickTo(follower, 'x', { duration: 0.4, ease: 'power3.out' }),
        yTo = gsap.quickTo(follower, 'y', { duration: 0.4, ease: 'power3.out' });

      function hideFollower() {
        follower.classList.remove('is-active');
      }
      function showFollower() {
        follower.classList.add('is-active');
      }
      function grabFollower() {
        follower.classList.add('is-grabbing');
      }
      function endgrabFollower() {
        follower.classList.remove('is-grabbing');
      }

      function toggleFollower(_x, _y) {
        if (isNaN(_x) || isNaN(_y)) {
          return false;
        }
        const current_target = document.elementFromPoint(_x, _y);
        if (current_target) {
          const scroll_container = current_target.closest('.swiper-free-mode')
            ? current_target.closest('.swiper-free-mode')
            : current_target.closest('.thumb__gallery')
            ? current_target.closest('.thumb__gallery')
            : null;
          if (!scroll_container || page_moving) {
            hideFollower();
          } else {
            showFollower();
          }
        } else {
          hideFollower();
        }
        position_cache.x = _x;
        position_cache.y = _y;
      }

      swup.hooks.on('animation:out:start', (visit) => {
        page_moving = true;
        hideFollower();
        endgrabFollower();
      });

      swup.hooks.on('animation:in:end', (visit) => {
        page_moving = false;
      });

      function moveFollower(e) {
        if (e.type != 'scroll') {
          toggleFollower(e.clientX, e.clientY);
          xTo(e.clientX);
          yTo(e.clientY);
        } else {
          if (position_cache.x != null && position_cache.y != null) {
            toggleFollower(position_cache.x, position_cache.y);
          }
        }
      }

      window.addEventListener('scroll', moveFollower);
      window.addEventListener('mousemove', moveFollower);
      window.addEventListener('swiperdragging', moveFollower);
      window.addEventListener('swiperdragstart', grabFollower);
      window.addEventListener('swiperdragend', endgrabFollower);

      function removeEvents() {
        window.removeEventListener('scroll', moveFollower);
        window.removeEventListener('mousemove', moveFollower);
        window.removeEventListener('swiperdragging', moveFollower);
        window.removeEventListener('swiperdragstart', grabFollower);
        window.removeEventListener('swiperdragend', endgrabFollower);
        hideFollower();
      }

      return () => {
        // optional
        removeEvents();
      };
    });
  }
}

function scrollClass() {
  let st_cache = document.scrollingElement.scrollTop;
  const _body = document.body;
  function check() {
    const current_st = document.scrollingElement.scrollTop;
    if (current_st > st_cache) {
      _body.classList.add('is-scrolling-down');
    } else {
      _body.classList.remove('is-scrolling-down');
    }
    st_cache = current_st;
  }
  window.addEventListener('scroll', check);
}

function newsPostTicker() {
  const container = document.querySelector('.menuNewsList__postContainer');
  if (!container) {
    return false;
  }

  // let mql = window.matchMedia('(max-width:800px)');
  const posts = container.querySelectorAll('.menuNewsList__post');
  function setProps() {
    const scroll_time_unit = 20;
    posts.forEach((post) => {
      const summary = post.querySelector('.summary');
      const ttl = post.querySelector('.ttl');
      if (!summary || !ttl) {
        return;
      }
      post.style.setProperty('--summary-width', `${summary.offsetWidth}px`);
      const length_to_scroll = ttl.scrollWidth - ttl.offsetWidth;
      if (length_to_scroll) {
        ttl.classList.add('ticker-active');
      } else {
        ttl.classList.remove('ticker-active');
      }
      ttl.style.setProperty('--length-to-scroll', `${length_to_scroll}px`);
      ttl.style.setProperty('--time-to-scroll', `${Math.max(length_to_scroll * scroll_time_unit, 4000)}ms`);
    });
  }
  setProps();
  window.addEventListener('resize', setProps);

  function activatePosts() {
    let post_index = 0;
    let prev_index = null;
    if (posts.length == 1) {
      posts[0].classList.add('post-active');
    } else {
      posts.forEach((post) => post.classList.remove('post-active'));
      function activateNext() {
        if (prev_index != null) {
          posts[prev_index].classList.remove('post-active');
        }
        posts[post_index].querySelector('.ttl').addEventListener('animationend', activateNext);
        posts[post_index].classList.add('post-active');
        prev_index = post_index;
        post_index = post_index + 1 == posts.length ? 0 : post_index + 1;
      }
      activateNext();
    }
  }
  // mql.addEventListener('change',activatePosts);
  activatePosts();
}

function bodyScrollToggle(bool) {
  const body = document.querySelector('body');
  if (bool) {
    body.__scroll_cache = document.documentElement.scrollTop || document.body.scrollTop;
    setTimeout(function () {
      body.style.top = `${-1 * body.__scroll_cache}px`;
      body.classList.add('fixed');
    }, 300);
  } else {
    body.classList.remove('fixed');
    body.style.top = 0;
    window.scrollTo(0, body.__scroll_cache);
  }
}

function menu() {
  // ヘッダーの検索窓領域を計算
  const header = document.querySelector('header.head');
  function searchModalRect() {
    if (!header) {
      return;
    }
    const rect = {
      top: window.innerHeight,
      left: window.innerWidth,
      right: window.innerWidth,
      width: 0,
      height: 0,
    };
    const container = document.querySelector('#headMenu');
    if (!container) {
      return;
    }
    const areas = container.querySelectorAll('.menuPageLists,.menuIconList');
    Array.from(areas).forEach((area) => {
      const _rect = area.getBoundingClientRect();
      rect.top = Math.min(rect.top, _rect.top);
      rect.left = Math.min(rect.left, _rect.left);
      rect.right = Math.min(rect.right, window.innerWidth - (_rect.left + _rect.width));
      rect.width = rect.width + _rect.width;
      rect.height = Math.max(rect.height, _rect.height);
    });
    // console.log(rect);
    header.style.setProperty('--pc-search-top', `${rect.top}px`);
    header.style.setProperty('--pc-search-left', `${rect.left}px`);
    header.style.setProperty('--pc-search-right', `${rect.right}px`);
    header.style.setProperty('--pc-search-width', `${rect.width}px`);
    header.style.setProperty('--pc-search-height', `${rect.height}px`);
  }

  // ヘッダーのログイン領域を計算
  function loginModalRect() {
    if (!header) {
      return;
    }
    const rect = {
      top: window.innerHeight,
      left: window.innerWidth,
      right: window.innerWidth,
      width: 0,
      height: 0,
    };
    const sp_rect = {
      top: window.innerHeight,
      left: window.innerWidth,
      right: window.innerWidth,
      width: 0,
      height: 0,
    };
    const container = document.querySelector('#headMenu');
    if (!container) {
      return;
    }
    const areas = container.querySelectorAll('.menuIconList');
    const sp_areas = document.querySelectorAll('.tbmin.head__rightbtn');

    Array.from(areas).forEach((area) => {
      const _rect = area.getBoundingClientRect();
      rect.top = Math.min(rect.top, _rect.top);
      rect.left = Math.min(rect.left, _rect.left);
      rect.right = Math.min(rect.right, window.innerWidth - (_rect.left + _rect.width));
      rect.width = rect.width + _rect.width;
      rect.height = Math.max(rect.height, _rect.height);
    });
    Array.from(sp_areas).forEach((area) => {
      const _sp_rect = area.getBoundingClientRect();
      // console.log(_sp_rect);
      sp_rect.top = Math.min(sp_rect.top, _sp_rect.top);
      // sp_rect.left = Math.min(sp_rect.left, _sp_rect.left);
      // sp_rect.right = Math.min(sp_rect.right, window.innerWidth - (_sp_rect.left + _sp_rect.width));
      sp_rect.width = sp_rect.width + _sp_rect.width;
      sp_rect.height = Math.max(sp_rect.height, _sp_rect.height);
    });
    // console.log(rect);
    header.style.setProperty('--pc-login-top', `${rect.top}px`);
    header.style.setProperty('--pc-login-left', `${rect.left}px`);
    header.style.setProperty('--pc-login-right', `${rect.right}px`);
    header.style.setProperty('--pc-login-width', `${rect.width}px`);
    header.style.setProperty('--pc-login-height', `${rect.height}px`);
    // console.log(sp_rect);
    header.style.setProperty('--sp-login-top', `${sp_rect.top}px`);
    header.style.setProperty('--sp-login-height', `${sp_rect.height}px`);
    header.style.setProperty('--sp-login-width', `${sp_rect.width}px`);
  }

  window.addEventListener('resize', searchModalRect);
  window.addEventListener('resize', loginModalRect);

  searchModalRect();
  loginModalRect();

  //Micromodal Copyright (c) 2017 Indrashish Ghosh
  MicroModal.init({
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
  });

  const menuBtn = document.getElementById('head__btn');
  const menu = document.getElementById('head__menu__wrap');
  flag = 0;

  function openModal(e) {
    // console.log(e.currentTarget);
    const target_id = e.currentTarget.dataset.modalTarget;
    if (target_id != null) {
      e.preventDefault();
      searchModalRect();
      MicroModal.show(target_id);
    }
  }
  document.querySelectorAll('[data-modal-target]').forEach((btn) => {
    btn.addEventListener('click', openModal);
  });

  function closeModals() {
    const modals = document.querySelectorAll('.micromodal-slide.modal.is-open');
    modals.forEach((modal) => {
      try {
        MicroModal.close(modal.id);
      } catch (err) {
        console.log(err);
      }
    });
  }

  function menuOpen() {
    if (!menuBtn || !menu) {
      return;
    }
    menuBtn.classList.add('is-active');
    menu.classList.add('is-shown');
    flag = 1;
    bodyScrollToggle(flag);
  }

  function menuClose() {
    if (!menuBtn || !menu) {
      return;
    }
    menuBtn.classList.remove('is-active');
    menu.classList.remove('is-shown');
    flag = 0;
    bodyScrollToggle(flag);
  }

  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      if (flag === 0) {
        menuOpen();
      } else {
        menuClose();
      }
    });
  }

  function initAccessAnchor() {
    const anchors = document.querySelectorAll('#headMenu a[href]');
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const current_url = new URL(location.href);
        const target_url = anchor.getAttribute('href').replace(/#.*/, '');
        if (current_url.pathname == target_url) {
          // 同ページへのリンクの場合すぐメニューを閉じる
          menuClose();
        }
      });
    });
  }
  initAccessAnchor();

  // SPメニューのタグクラウドをアコーディオンに
  function initTagAccordion() {
    const container = document.querySelector('.tbmin.head__menu__search');
    if (!container) {
      return false;
    }
    const accordion = container.querySelector('ul');
    const btn = container.querySelector('.toggleAccordion');
    function openAccordion() {
      accordion.addEventListener(
        'transitionend',
        () => {
          accordion.classList.add('is-open');
          accordion.style.maxHeight = ''; // アコーディオンの高さを自動に戻す
        },
        { once: true }
      );
      accordion.dataset.defaultHeight = accordion.style.maxHeight;
      accordion.style.maxHeight = `${accordion.scrollHeight}px`;
      btn.classList.add('is-open');
      btn.querySelector('.txt').textContent = btn.dataset.closeText;
    }
    function closeAccordion() {
      accordion.style.maxHeight = `${accordion.scrollHeight}px`;
      requestAnimationFrame(() => {
        accordion.addEventListener(
          'transitionend',
          () => {
            accordion.style.maxHeight = ''; // アコーディオンの高さを自動に戻す
          },
          { once: true }
        );
        accordion.style.maxHeight = accordion.dataset.defaultHeight;
        accordion.classList.remove('is-open');
        btn.classList.remove('is-open');
        btn.querySelector('.txt').textContent = btn.dataset.openText;
      });
    }
    function toggleAccordion() {
      if (accordion.classList.contains('is-open')) {
        closeAccordion();
      } else {
        openAccordion();
      }
    }
    btn.addEventListener('click', toggleAccordion);
  }
  initTagAccordion();

  // ページ遷移時にメニューを閉じるようにする
  try {
    swup.hooks.on('link:click', (v) => {
      closeModals();
    });
    swup.hooks.on('animation:out:end', menuClose);
  } catch (err) {}
}

function filter() {
  const filter = document.getElementById('cmnFilterbtn');

  if (filter) {
    const side = document.querySelector('.cmnSide');

    filter.addEventListener('click', function () {
      side.classList.toggle('is-active');
      if (side.classList.contains('is-active')) {
        bodyScrollToggle(true);
      } else {
        bodyScrollToggle(false);
      }
    });
  }
}

function floorGuide() {
  if(!document.querySelector('.topFloorGuide__slider')) {
    console.log('no floor guide');
    return false;
  }
  const index_offset = 1;
  const indicator = document.querySelector('.topFloorGuide__slider__indicator');
  const pagination = document.querySelector('.topFloorGuide__slider__pagination');
  const swiper = new Swiper('.topFloorGuide__slider', {
    speed: 1000,
    parallax: true,
    loop: true,
    loopAddBlankSlides: index_offset,
    slidesPerView: 1,
    // effect: 'fade',
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: pagination,
      clickable: true,
    },
    // navigation: {
    //   nextEl: next_btn,
    //   prevEl: prev_btn,
    // },
    onAny(eventName, ...args) {
      try {
        if (eventName == 'touchMove') {
          const event = new Event('swiperdragging');
          event.clientX = args[1].clientX;
          event.clientY = args[1].clientY;
          window.dispatchEvent(event);
        } else if (eventName == 'touchStart') {
          const event = new Event('swiperdragstart');
          window.dispatchEvent(event);
        } else if (eventName == 'touchEnd') {
          const event = new Event('swiperdragend');
          window.dispatchEvent(event);
        } else if (eventName == 'init') {
          // if (container) {
          // const targets01 = container.querySelectorAll('.img');
          // const targets02 = container.querySelectorAll('.cont');
          // if (targets01) {
          //   container.matchHeight({ elements: '.img' });
          // }
          // if (targets02) {
          //   container.matchHeight({ elements: '.cont' });
          // }
          // }
        }
      } catch (err) {}
    },
  });
  if (indicator) {
    function dispStatus(swpr, time, progress_left) {
      if (!window.Power1) {
        indicator.style.setProperty('--progress_left', 1 - progress_left);
      } else {
        indicator.style.setProperty('--progress', 1 - window.Power1.easeInOut(progress_left));
      }
    }
    swiper.on('autoplayTimeLeft', dispStatus);
  }
  // const swiper = new Swiper('.topFloorGuide__slider', {
  //   centeredSlides: true,
  //   speed: 1000,
  //   parallax: true,
  //   loop: true,
  //   loopAddBlankSlides: index_offset,
  //   slidesPerView: 1,
  //   autoplay: {
  //     delay: 6000,
  //     disableOnInteraction: false,
  //   },
  //   pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true,
  //   },
  //   on: {
  //     autoplayTimeLeft(s, time, progress) {
  //       const bullets = indicator.querySelectorAll('.swiper-pagination-bullet');
  //       const active_bullet = indicator.querySelector('.swiper-pagination-bullet.swiper-pagination-bullet-active');
  //       let before_flg = false;
  //       [...bullets].forEach((bullet, i) => {
  //         if (bullet == active_bullet) {
  //           before_flg = true;
  //           if (window.Power2) {
  //             bullet.style.setProperty('--progress', 1 - window.Power2.easeInOut(progress));
  //           } else {
  //             bullet.style.setProperty('--progress', 1 - progress);
  //           }
  //         } else if (before_flg) {
  //           bullet.style.setProperty('--progress', 0);
  //         } else {
  //           bullet.style.setProperty('--progress', 1);
  //         }
  //       });
  //     },
  //   },
  // });
  const rooms = document.querySelectorAll('.room-clickable');
  rooms.forEach((room) => {
    room.addEventListener('click', (e) => {
      const clicked = e.currentTarget;
      const room_index = clicked.dataset.roomIndex;
      swiper.slideToLoop(room_index);
    });
  });
  function setState(swpr) {
    const index = swpr.realIndex;
    const slides = swpr.slides;
    const current_slide = slides[swpr.activeIndex];
    const current_floor = current_slide.dataset.floor;

    const floor_indicators_01 = document.querySelectorAll('.topFloorGuide__num-item');
    const floor_indicator_02 = document.querySelector('.topFloorGuide__slider__currentFloor__inner');
    const floor_texts = document.querySelectorAll('.topFloorGuide__name-item');
    const floor_maps = document.querySelectorAll('.topFloorGuide__svg__item');

    const rooms = document.querySelectorAll('.topFloorGuide__svg__item .room-clickable');

    if (!rooms.length || !floor_indicators_01 || !floor_indicator_02) {
      return;
    }
    if (current_floor == '1F') {
      floor_indicators_01[0].classList.add('is-active');
      floor_indicators_01[1].classList.remove('is-active');
      floor_indicator_02.classList.remove('upstairs');
      floor_maps[0].classList.add('is-active');
      floor_maps[1].classList.remove('is-active');
      floor_texts[0].classList.add('is-active');
      floor_texts[1].classList.remove('is-active');
    } else {
      floor_indicators_01[0].classList.remove('is-active');
      floor_indicators_01[1].classList.add('is-active');
      floor_indicator_02.classList.add('upstairs');
      floor_maps[0].classList.remove('is-active');
      floor_maps[1].classList.add('is-active');
      floor_texts[0].classList.remove('is-active');
      floor_texts[1].classList.add('is-active');
    }

    rooms.forEach((room, _index) => {
      if (index == _index) {
        room.classList.add('room-current');
      } else {
        room.classList.remove('room-current');
      }
    });
  }
  setState(swiper);

  swiper.on('slideChange', setState);
}

function alignItemsHeight(_containers) {
  let containers = _containers ? _containers : document.querySelectorAll('.cmnItemList');
  if (Array.isArray(containers)) {
    containers = [containers];
  }
  if (containers) {
    containers.forEach((container) => {
      function initMatchHeight() {
        container.matchHeight({ elements: '.img' });
        container.matchHeight({ elements: '.brand' });
        container.matchHeight({ elements: '.cat' });
        const items = container.querySelectorAll('li');
        items.forEach((elem, idx) => {
          elem.classList.add('is-ready');
        });
      }
      imagesLoaded(container, initMatchHeight);
    });
  }
}

function cmnSwiper() {
  if (document.querySelector('.cmnSwiper01')) {
    Array.from(document.querySelectorAll('.cmnSwiper01')).forEach((slider) => {
      const prev_btn = slider.querySelector('.cmnSwiper01__nav__btn.is-prev');
      const next_btn = slider.querySelector('.cmnSwiper01__nav__btn.is-next');
      const pagination = slider.querySelector('.cmnSwiper01__pagination');
      const indicator = slider.querySelector('.cmnSwiper01__indicator');
      const slides = slider.querySelectorAll('.swiper-slide');

      const autoplay_settings = slides.length > 1 ? { delay: 6000 } : false;
      const swiper = new Swiper(slider, {
        speed: 1000,
        loop: true,
        loopAddBlankSlides: 1,
        slidesPerView: 1,
        // effect: 'fade',
        autoplay: autoplay_settings,
        pagination: {
          el: pagination,
          clickable: true,
        },
        navigation: {
          nextEl: next_btn,
          prevEl: prev_btn,
        },
        onAny(eventName, ...args) {
          try {
            if (eventName == 'touchMove') {
              const event = new Event('swiperdragging');
              event.clientX = args[1].clientX;
              event.clientY = args[1].clientY;
              window.dispatchEvent(event);
            } else if (eventName == 'touchStart') {
              const event = new Event('swiperdragstart');
              window.dispatchEvent(event);
            } else if (eventName == 'touchEnd') {
              const event = new Event('swiperdragend');
              window.dispatchEvent(event);
            } else if (eventName == 'init') {
              // if (container) {
              //   const targets01 = container.querySelectorAll('.img');
              //   const targets02 = container.querySelectorAll('.cont');
              //   if (targets01) {
              //     container.matchHeight({ elements: '.img' });
              //   }
              //   if (targets02) {
              //     container.matchHeight({ elements: '.cont' });
              //   }
              // }
            }
          } catch (err) {}
        },
      });
      if (indicator) {
        function dispStatus(swpr, time, progress_left) {
          if (!window.Power1) {
            indicator.style.setProperty('--progress', 1 - progress_left);
          } else {
            indicator.style.setProperty('--progress', 1 - window.Power1.easeInOut(progress_left));
          }
        }
        swiper.on('autoplayTimeLeft', dispStatus);
        dispStatus(null, null, 1);
      }
    });
  }
}

function topPage() {
  const topPage = document.getElementById('top');

  if (topPage) {
    // FloorMap
    floorGuide();
  }
}

function freeScrollContainer() {
  const containers = document.querySelectorAll('.horizontal-scroll-container');
  Array.from(containers).forEach((container) => {
    new Swiper(container, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      freeMode: true,
      onAny(eventName, ...args) {
        try {
          if (eventName == 'touchMove') {
            const event = new Event('swiperdragging');
            event.clientX = args[1].clientX;
            event.clientY = args[1].clientY;
            window.dispatchEvent(event);
          } else if (eventName == 'touchStart') {
            const event = new Event('swiperdragstart');
            window.dispatchEvent(event);
          } else if (eventName == 'touchEnd') {
            const event = new Event('swiperdragend');
            window.dispatchEvent(event);
          } else if (eventName == 'init') {
            if (container) {
              const targets01 = container.querySelectorAll('.img');
              const targets02 = container.querySelectorAll('.cont');
              if (targets01) {
                container.matchHeight({ elements: '.img' });
              }
              if (targets02) {
                container.matchHeight({ elements: '.cont' });
              }
            }
          }
        } catch (err) {}
      },
    });
  });
}

function productPage() {
  // 商品ページのスライダー
  function initProductMainSlider() {
    if (!document.querySelector('.thumb__gallery')) {
      return false;
    }
    const swiper1 = new Swiper('.thumb__gallery', {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      onAny(eventName, ...args) {
        if (eventName == 'touchMove') {
          const event = new Event('swiperdragging');
          event.clientX = args[1].clientX;
          event.clientY = args[1].clientY;
          window.dispatchEvent(event);
        } else if (eventName == 'touchStart') {
          const event = new Event('swiperdragstart');
          window.dispatchEvent(event);
        } else if (eventName == 'touchEnd') {
          const event = new Event('swiperdragend');
          window.dispatchEvent(event);
        }
      },
    });
    const swiper2 = new Swiper('.thumb__main', {
      effect: 'fade',
      speed: 400,
      thumbs: {
        swiper: swiper1,
      },
    });
  }
  initProductMainSlider();

  // 商品詳細ドロップダウンを生成
  function initProductTable() {
    const items = document.querySelectorAll('.itemsSingleMainDetail__cont .product-spec');
    const container = document.querySelector('.detailBox');
    if (!container || !items) {
      return false;
    }
    // container.innerHTML = '';
    if (items) {
      function appendRow(item) {
        const template = document.querySelector('#detailBoxItem');
        if (template) {
          const instance = template.content.cloneNode(true);
          instance.querySelector('.detailBox__btn .text').innerHTML =
            item.querySelector('.product-spec__title').innerHTML;
          instance.querySelector('.detailBox__cont__inner').innerHTML =
            item.querySelector('.product-spec__content').innerHTML;
          container.append(instance);
        }
      }
      items.forEach(appendRow);
    }
  }
  initProductTable();

  function initFavBtn() {
    const real_button = document.querySelector('[id*="shopify-block-basic_wishlist_buttons_"] loo-prodpage-button');
    const proxy_btn = document.querySelector('.itemsMain button.like');
    if (real_button && proxy_btn) {
      function asyncBtnState() {
        const txt_container = proxy_btn.querySelector('span');
        if (real_button.classList.contains('loo-added')) {
          proxy_btn.classList.add('added');
          txt_container.textContent = 'LIKED';
        } else {
          proxy_btn.classList.remove('added');
          txt_container.textContent = 'LIKE';
        }
      }
      asyncBtnState();
      getItemVendors();

      // (変更を監視する) オブザーバーのオプション
      const config = { attributes: true, childList: false, subtree: false };

      // コールバック関数に結びつけられたオブザーバーのインスタンスを生成
      const observer = new MutationObserver(() => {
        asyncBtnState();
        getItemVendors();
      });

      // 対象ノードの設定された変更の監視を開始
      observer.observe(real_button, config);

      proxy_btn.addEventListener('click', (e) => {
        real_button.click();
      });
    }
  }
  initFavBtn();

  // APIでおすすめを取得
  function initRecommendations() {
    const recommendations_area = document.querySelector('.product-recommendations');
    if (recommendations_area) {
      fetch(recommendations_area.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          recommendations_area.innerHTML = text;
          setTimeout(() => {
            alignItemsHeight(recommendations_area.querySelectorAll('.cmnItemList'));
          }, 50);
        })
        .catch((e) => {
          console.error(e);
          recommendations_area.remove();
        });
    }
  }
  initRecommendations();
}

function itemsCatArchive() {
  const swiperThumbnail = new Swiper('.itemsArcCatinfo__thumbslider', {
    slidesPerView: 3,
    // spaceBetween: 8,
    freeMode: true,
    watchSlidesProgress: true,
  });

  const swiperMain = new Swiper('.itemsArcCatinfo__mainslider', {
    effect: 'fade',
    loop: true,
    thumbs: {
      swiper: swiperThumbnail,
    },
  });
}

function storyPage() {
  const storyPage = document.getElementById('storyArc');

  // if (storyPage) {
  //   const swiper = new Swiper('.cmnSwiper01', {
  //     speed: 600,
  //     effect: 'fade',
  //     navigation: {
  //       nextEl: '.cmnSwiper01__nav__btn.is-next',
  //       prevEl: '.cmnSwiper01__nav__btn.is-prev',
  //     },
  //   });
  // }
}

function storySingle() {
  const wrapper = document.querySelector('.storySingleMain');
  if (wrapper) {
    // 画像関連の処理
    const img_container = wrapper.querySelector('.img');
    const content_container = wrapper.querySelector('.content');
    const imgs = content_container ? content_container.querySelectorAll('img') : null;
    if (imgs && imgs.length && img_container) {
      function checkFramein(entries) {
        entries.forEach((entry) => {
          // console.log(entry.boundingClientRect);
          const tgt = entry.target.target_img;
          if (entry.isIntersecting) {
            tgt.classList.add('is-active');
          } else {
            tgt.classList.remove('is-active');
          }
        });
      }
      let observer = new IntersectionObserver(checkFramein, {
        threshold: 0,
        rootMargin: '10% 0px 10% 0px',
      });
      [...imgs].forEach((img) => {
        const _img = img.cloneNode(true);
        img_container.appendChild(_img);
        img.target_img = _img;
        observer.observe(img);
      });
    } else if (img_container) {
      img_container.remove();
    }

    // 外部リンクの末尾にアイコンを挿入
    const anchors = wrapper.querySelectorAll('a[target=_blank]');
    if (anchors) {
      [...anchors].forEach((elem) => {
        const _icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const _use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        _use.setAttribute('href', '#icon-blank2');
        _icon.appendChild(_use);
        _icon.setAttribute('width', 12);
        _icon.setAttribute('height', 12);
        elem.appendChild(_icon);
      });
    }

    // 連続するスペース用のpタグをSPで非表示に
    const content_body = wrapper.querySelector('.content__detail');
    const space_patterns = ['&nbsp;', '<span>&nbsp;</span>', '<span class="Apple-converted-space">&nbsp;</span>'];
    if (content_body) {
      const paragraphs = content_body.querySelectorAll('p');
      let is_prev_paragraph_space = false;
      [...paragraphs].forEach((p) => {
        const inner_html = String(p.innerHTML)
          .trim()
          .replace(/[ 　]{2,}/g, '');
        console.log(inner_html);

        if (space_patterns.some((pattern) => inner_html == pattern)) {
          if (is_prev_paragraph_space) {
            p.classList.add('ltb');
          } else {
            is_prev_paragraph_space = true;
          }
        } else {
          is_prev_paragraph_space = false;
        }
      });
    }
  }
}

function newsLetterPage() {
  const btn = document.querySelector('#submitButton');
  if (btn) {
    function bindUpTags(e) {
      // e.preventDefault();
      const _form = this.closest('form');
      const tags = _form.querySelectorAll('.text-to-collect,.check-to-collect:checked');
      const str = Array.from(tags)
        .map((elem) => {
          const prefix = elem.dataset.labelPrefix != null ? elem.dataset.labelPrefix : '';
          return prefix + elem.value;
        })
        .join(',');
      _form.querySelector('#Newsletter-tags').value = `newsletter,${str}`;
    }
    btn.addEventListener('click', bindUpTags);
  }
}

function gallery() {
  const elem = document.querySelector('.cmnGallerySlider');
  if (elem) {
    const parent = elem.parentElement;
    const thumbs_container = parent.querySelector('.cmnGallerySlider__thumbs');
    if (thumbs_container) {
      const slides = elem.querySelectorAll('.swiper-slide');
      const slider = new Swiper(elem, {
        speed: 800,
        effect: 'fade',
        pagination: {
          el: thumbs_container,
          clickable: true,
          renderBullet: function (index, className) {
            const img = slides[index].innerHTML;
            return '<li class="' + className + '">' + img + '</li>';
          },
        },
      });
    } else {
      const slider = new Swiper(elem, {
        speed: 800,
        effect: 'fade',
      });
    }
  }
}

function accordion() {
  const item = document.querySelectorAll('.cmnAccordion__item');
  const hash = location.hash;
  item.forEach((item) => {
    const btn = item.querySelector('.cmnAccordion__btn');
    if (!btn) {
      return;
    }

    btn.addEventListener('click', (e) => {
      const elm = e.target.nextElementSibling;

      e.target.classList.toggle('is-active');
      elm.classList.toggle('is-active');
      if (elm.classList.contains('is-active')) {
        elm.style.height = elm.scrollHeight + 'px';
      } else {
        elm.style.height = '0';
      }
    });

    if (hash != null && hash != '') {
      const _id = hash.replace(/^#/, '');
      if (item.id == _id) {
        btn.click();
      }
    }
  });
}
